module.exports = __webpack_public_path__ + "img/appBg--dots.d44cf9ed.svg";